import React, { useState } from 'react';
import './auth.css';
import useResetPasswordRequest from '../../hooks/authentication/useResetPasswordRequest';
import useAuthSubmit from '../../hooks/authentication/useAuthSubmit';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import PasswordRecoveryForm from './PasswordRecoveryForm';
import { useAuth } from '../../context/AuthContext';
import TermsModal from './TermsModal';

const Auth = ({ isSignUp, userType }) => {
  const { resetPasswordRequest } = useResetPasswordRequest();
  const { onSubmit, error } = useAuthSubmit(isSignUp, userType);
  const { login } = useAuth();

  const [formState, setFormState] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    phoneNumber: '',
    referralSource: '',
    termsAccepted: false,
  });

  const [isRecoveringPassword, setIsRecoveringPassword] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleChange = (e) => {
    const val = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormState({
      ...formState,
      [e.target.name]: val,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(formState);
  };

  const handleGoogleSignInSuccess = (userData) => {
    // Update the auth context with the Google user data
    login(userData);
  };

  const handlePasswordRecovery = async () => {
    await resetPasswordRequest(formState.email);
    setIsRecoveringPassword(false);
  };

  const handleBack = () => {
    setIsRecoveringPassword(false);
  };

  return (
      <div className="auth__container">
        {isRecoveringPassword ? (
           <PasswordRecoveryForm
              formState={formState}
              handleChange={handleChange}
              handleSubmit={handlePasswordRecovery}
              error={error}
              handleBack={handleBack}
           />
        ) : (
          <>
            {isSignUp ? (
              <SignUpForm
                formState={formState}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                error={error}
                userType={userType}
                onShowTerms={() => setShowTerms(true)}
                onGoogleSignInSuccess={handleGoogleSignInSuccess}
              />
            ) : (
              <SignInForm
                formState={formState}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                error={error}
                userType={userType}
                onGoogleSignInSuccess={handleGoogleSignInSuccess}
              />
            )}
            {!isSignUp && (
              <button
                onClick={() => setIsRecoveringPassword(true)}
                className="auth__recover-button"
              >
                Recupera tu contraseña
              </button>
            )}
          </>
        )}
        <TermsModal open={showTerms} onClose={() => setShowTerms(false)} />
      </div>
  );
};

export default Auth;
